<template>
  <node-view-wrapper class="text-input">
    <v-card v-if="!node.attrs.formulateSchema" max-width="400px">
      <v-card-title>Add an input:</v-card-title>
      <v-card-text>
        <FormulateInput
          type="select"
          name="type"
          v-model="type"
          :options="['Text', 'Date', 'Number', 'File', 'Checkbox', 'Radio']"
          label="Select a type"
        />

        <FormulateInput
          name="label"
          v-model="label"
          type="text"
          label="Give your input type a title"
        />

        <FormulateInput
          v-if="type === 'Text'"
          name="text"
          v-model="value"
          type="text"
          label="Give your input type a value"
        />

        <FormulateInput
          v-else-if="type === 'Date'"
          v-model="value"
          type="vue-datetime"
          datetype="date"
          name="date"
          label="Please select a date"
        />

        <FormulateInput
          v-else-if="type === 'Number'"
          name="number"
          v-model="value"
          type="number"
          label="Give your input type a value"
        />

        <FormulateInput
          v-else-if="type === 'File'"
          name="file"
          v-model="value"
          type="file"
          label="Please select a file to upload"
        />

        <FormulateForm
          v-else-if="type === 'Checkbox'"
          v-model="optionForm"
          :form-errors="
            optionFormError
              ? [
                  'Please make sure none of the below items have the same value.',
                ]
              : []
          "
        >
          <FormulateInput
            v-for="(v, i) in amount"
            :key="i"
            type="text"
            :label="'option ' + v"
          />
        </FormulateForm>

        <FormulateForm
          v-else
          v-model="optionForm"
          :form-errors="
            optionFormError
              ? [
                  'Please make sure none of the below items have the same value.',
                ]
              : []
          "
        >
          <FormulateInput
            v-for="(v, i) in amount"
            :key="i"
            type="text"
            :label="'option ' + v"
          />
        </FormulateForm>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="setSchema" :disabled="label.length == 0" color="primary">
          Ok
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="type === 'Checkbox' || type === 'Radio'"
          @click="amount++"
          color="primary"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="type === 'Checkbox' || type === 'Radio'"
          @click="amount--"
          :disabled="amount === 1"
          color="primary"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else class="p-5" max-width="400px" elevation="0">
      <FormulateForm
        :schema="node.attrs.formulateSchema"
        v-model="formValues"
      />
    </v-card>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from "@tiptap/vue-2";

export default {
  data() {
    return {
      type: "Text",
      value: "",
      label: "",
      formValues: {},
      amount: 1,
      optionForm: {},
      optionFormError: false,
    };
  },
  components: {
    NodeViewWrapper,
  },
  props: {
    node: {
      type: Object,
      required: true,
    },
    updateAttributes: {
      type: Function,
      required: true,
    },
  },
  methods: {
    setSchema() {
      let options = [];
      const values = Object.values(this.optionForm);
      const duplicate = values.length !== new Set(values).size;
      if (duplicate) {
        this.optionFormError = true;
        return;
      }
      switch (this.type) {
        case "Text":
          this.updateAttributes({
            formulateSchema: [
              {
                label: this.label,
                name: _.snakeCase(this.label),
                value: this.value,
                type: "text",
              },
            ],
          });
          break;
        case "Date":
          this.updateAttributes({
            formulateSchema: [
              {
                label: this.label,
                name: _.snakeCase(this.label),
                value: this.value,
                type: "vue-datetime",
                datetype: "date",
              },
            ],
          });
          break;
        case "Number":
          this.updateAttributes({
            formulateSchema: [
              {
                label: this.label,
                name: _.snakeCase(this.label),
                value: this.value,
                type: "number",
              },
            ],
          });
          break;
        case "File":
          this.updateAttributes({
            formulateSchema: [
              {
                label: this.label,
                name: _.snakeCase(this.label),
                value: this.value,
                type: "file",
              },
            ],
          });
          break;
        case "Checkbox":
          for (const key in this.optionForm) {
            const element = this.optionForm[key];
            const option = {
              value: element,
              name: _.snakeCase(element),
              label: element,
            };
            options.push(option);
          }
          this.updateAttributes({
            formulateSchema: [
              {
                type: "checkbox",
                name: _.snakeCase(this.label),
                label: this.label,
                options,
                value: this.value,
              },
            ],
          });
          break;
        case "Radio":
          for (const key in this.optionForm) {
            const element = this.optionForm[key];
            const option = {
              value: element,
              name: _.snakeCase(element),
              label: element,
            };
            options.push(option);
          }
          this.updateAttributes({
            formulateSchema: [
              {
                type: "radio",
                name: _.snakeCase(this.label),
                label: this.label,
                options,
                value: this.value,
              },
            ],
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.v-tooltip__content {
  pointer-events: initial;
}
.disable-events {
  pointer-events: none;
}
</style>
